import { render, staticRenderFns } from "./SubjectSelectCard.vue?vue&type=template&id=be827fc6&scoped=true"
import script from "./SubjectSelectCard.vue?vue&type=script&lang=js"
export * from "./SubjectSelectCard.vue?vue&type=script&lang=js"
import style0 from "./SubjectSelectCard.vue?vue&type=style&index=0&id=be827fc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be827fc6",
  null
  
)

export default component.exports